

export default {
    totalKodeAkun: 0,
    totalMaster: 0,
    totalSetting: 0,
    totalPembagian: 0,
    kodeAkunList: [],
    masterList: [],
    pembagianList: []
}
